import { Main } from "./main";
import "styles/header.css";

export const WatchLater = () => {
  return (
    <>
      <Main />
    </>
  );
};
